import React from 'react';
import { Paper, Typography, Divider } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import { coloresEmma } from '../../../../global/js/funciones';
import SemanaHorario from './SemanaHorario';

/**
 * Aviso que ve el estudiante cuando intenta crear una solicitud fuera de horario.
 */

/** Extrae el número marcable de un texto libre como "la línea 300 300 3333". */
const telefonoDe = (texto) => {
    const digitos = String(texto || '').replace(/[^\d+]/g, '');
    return digitos.length >= 7 ? digitos : null;
};

export default function AvisoFueraHorario({ horario }) {
    const proxima = (horario && horario.proxima_apertura_texto) || '';
    const linea = (horario && horario.linea_atencion) || '';
    const dias = (horario && horario.dias) || [];
    const telefono = telefonoDe(linea);

    return (
        <Paper
            elevation={0}
            style={{
                border: '1px solid #ececec',
                borderLeft: `4px solid ${coloresEmma.primarycolor}`,
                borderRadius: 6,
                padding: '15px 18px 17px',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 9 }}>
                <AccessTimeIcon style={{ color: coloresEmma.primarycolor, fontSize: 18 }} />
                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                    Fuera del horario de atención
                </Typography>
            </div>

            {proxima ? (
                <>
                    <Typography variant="caption" display="block" style={{ color: '#757575' }}>
                        Podrás crear tu solicitud el
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 17,
                            fontWeight: 500,
                            color: '#212121',
                            lineHeight: 1.3,
                            marginTop: 1,
                        }}
                    >
                        {proxima}
                    </Typography>
                </>
            ) : (
                <Typography variant="body2" style={{ color: '#616161', lineHeight: 1.7 }}>
                    {(horario && horario.mensaje) || 'En este momento no se están recibiendo solicitudes.'}
                </Typography>
            )}

            {linea && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 9,
                    marginTop: 11,
                    padding: '8px 12px',
                    backgroundColor: coloresEmma.serchover,
                    borderRadius: 6,
                }}>
                    <PhoneInTalkIcon style={{ color: coloresEmma.primarycolor, fontSize: 17 }} />
                    <Typography variant="body2" style={{ color: '#424242' }}>
                        ¿Necesitas atención inmediata? Comunícate con{' '}
                        {telefono ? (
                            <a
                                href={`tel:${telefono}`}
                                style={{ color: coloresEmma.primarycolor, fontWeight: 600, textDecoration: 'none' }}
                            >
                                {linea}
                            </a>
                        ) : (
                            <span style={{ fontWeight: 600 }}>{linea}</span>
                        )}
                    </Typography>
                </div>
            )}

            {dias.length > 0 && (
                <>
                    <Divider style={{ margin: '13px 0 9px' }} />
                    <Typography
                        variant="caption"
                        display="block"
                        style={{
                            color: '#9e9e9e',
                            fontWeight: 600,
                            letterSpacing: '.06em',
                            marginBottom: 6,
                        }}
                    >
                        HORARIO DE ATENCIÓN
                    </Typography>
                    <SemanaHorario dias={dias} compacto />
                </>
            )}
        </Paper>
    );
}
